import { z } from 'zod';

const envSchema = z.object({
  VITE_AUTH_MODE: z.enum(['demo', 'supabase']).default('demo'),
  VITE_SUPABASE_URL: z.string().url().optional().or(z.literal('')),
  VITE_SUPABASE_ANON_KEY: z.string().optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('V4 environment validation failed', parsed.error.flatten().fieldErrors);
}

export const env = parsed.success
  ? parsed.data
  : { VITE_AUTH_MODE: 'demo' as const, VITE_SUPABASE_URL: '', VITE_SUPABASE_ANON_KEY: '' };

export function assertSupabaseEnv() {
  if (!env.VITE_SUPABASE_URL || !env.VITE_SUPABASE_ANON_KEY) {
    throw new Error('Supabase认证尚未配置，请先设置VITE_SUPABASE_URL和VITE_SUPABASE_ANON_KEY。');
  }
}
